import { render, staticRenderFns } from "./PedidoProveedorForm.vue?vue&type=template&id=45136b87&"
import script from "./PedidoProveedorForm.vue?vue&type=script&lang=js&"
export * from "./PedidoProveedorForm.vue?vue&type=script&lang=js&"
import style0 from "./PedidoProveedorForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports